import { useTranslations } from '@vocab/react';
import { Actions, Box, Button } from 'braid-design-system';
import React, { type FunctionComponent } from 'react';

import { PreviewButton } from 'src/app/views/shared/PreviewButton';
import type { ValidationResultType } from 'src/types/validation';

import translations from './.vocab';
import { SaveDraftButton } from './components/SaveDraftButton';
interface Props {
  isLoading?: boolean;
  showPreviewButton?: boolean;
  handleSaveDraftFailed: () => void;
  handleValidation: () => Promise<ValidationResultType> | ValidationResultType;
}

export const PageButtons: FunctionComponent<Props> = ({
  isLoading = false,
  showPreviewButton = false,
  handleSaveDraftFailed,
  handleValidation,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Box paddingX={['gutter', 'none']}>
      <Actions>
        <Button type="submit" id="next-page-button" loading={isLoading}>
          {t('page-buttons-continue-label')}
        </Button>

        {showPreviewButton && <PreviewButton />}
        <SaveDraftButton
          handleSaveDraftFailed={handleSaveDraftFailed}
          handleValidation={handleValidation}
        />
      </Actions>
    </Box>
  );
};
